import {useMutation} from '@tanstack/react-query';
import {BackendResponse} from '../../http/backend-response/backend-response';
import {apiClient, queryClient} from '../../http/query-client';
import {useUserNotifications} from '../dialog/requests/user-notifications';
import {showHttpErrorToast} from '../../http/show-http-error-toast';
import {
  mergeBootstrapData,
  useBootstrapDataStore,
} from '@ui/bootstrap-data/bootstrap-data-store';

interface Response extends BackendResponse {
  unreadCount: number;
}

export function useGetNotificationsCount() {
  const data = useBootstrapDataStore(s => s.data);
  return useMutation({
    mutationFn: () => UseGetNotificationsCount(),
    onSuccess: response => {
      queryClient.invalidateQueries({queryKey: useUserNotifications.key});
      mergeBootstrapData({
        user: {...data.user!, unread_notifications_count: response.unreadCount},
      });
    },
    onError: err => showHttpErrorToast(err),
  });
}

function UseGetNotificationsCount(): Promise<Response> {
  return apiClient
    .get('notifications/count')
    .then(r => r.data);
}
